<template lang="pug">
  div
    clinic-title
    v-container
      phone-input-display.my-2.px-4(v-model="phone.number" :key="phoneInputKey" :dialNumber="phone.dialNumber" :isLoading="phone.loading" :isNewCustomer="isNewCustomer" :isReset="phone.reset" @error="handlePhoneError" @changeCountry="handleCountryChange")
      dial-input.my-2(v-model="phone.dialNumber" ref="dialInput")
      v-btn.button-lg.white--text.mb-6(block color="neutral700" depressed :disabled="!canContinue" @click="handleContinue") Continue
    .dialogs
      new-customer-dialog(v-if="newCustomer.open" :open.sync="newCustomer.open" :phone="newCustomer.data.phone" :loyalty-system="loyaltySystem" @close="resetAll")
      todo-dialog(v-if="todo.open" :open.sync="todo.open" :loyaltySystem="loyaltySystem" :profile="profile" @close="resetAll" @redeemed="handleRewardRedeemed" @applied="handleOfferApplied")
</template>

<script>
import {debounce} from "@/utils";
import {mapActions, mapGetters} from "vuex";
import DialInput from "@/components/marketing/merchantapp/collect/DialInput.vue";
import PhoneInput from "@/components/marketing/merchantapp/collect/PhoneInput.vue";
import ClinicTitle from "@/components/marketing/merchantapp/collect/ClinicTitle.vue";
import PhoneInputDisplay from "@/components/marketing/merchantapp/collect/PhoneInputDisplay.vue";
import NewCustomerDialog from "@/components/marketing/merchantapp/dialogs/NewCustomerDialog.vue";
import TodoDialog from "@/components/marketing/merchantapp/dialogs/TodoDialog.vue";
import RedeemRewardDialog from "@/components/marketing/merchantapp/dialogs/RedeemRewardDialog.vue";

export default {
  components: {
    RedeemRewardDialog,
    TodoDialog,
    NewCustomerDialog,
    PhoneInputDisplay,
    ClinicTitle,
    DialInput,
    PhoneInput
  },
  data() {
    return {
      phoneInputKey: 0,
      phone: {
        dialNumber: null,
        number: null,
        error: true,
        loading: false,
        reset: true
      },
      newCustomer: {
        open: false,
        data: null
      },
      todo: {
        open: false,
        data: null
      },
      canContinue: false,
    }
  },
  watch: {
    'phone.dialNumber'() {
      this.inputChanged()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      settings: 'marketing/getMarketingSettings',
      profile: 'marketing/getMember',
    }),
    canProceedFindMember() {
      return !this.phone.error && this.phone.dialNumber?.length > 0
    },
    loyaltySystem() {
      return this.settings?.loyalty_system
    },
    isNewCustomer() {
      return this.newCustomer.data !== null
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    handlePhoneError(value) {
      this.phone.error = value
    },
    handleCountryChange() {
      setTimeout(() => {
        this.checkLoyaltyMember()
      }, 500)
    },
    handleContinue() {
      if (this.isNewCustomer) {
        this.newCustomer.open = true
        return
      }
      this.todo.open = true
    },
    handleRewardRedeemed() {
      this.todo.open = false
      this.resetAll()
    },
    handleOfferApplied() {
      this.offerApplied.open = true
      this.todo.open = false
    },
    resetAll() {
      this.phoneInputKey++
      this.phone = {
        dialNumber: null,
        number: null,
        error: true,
        loading: false,
        reset: true
      }
      this.newCustomer = {
        open: false,
        data: null
      }
      this.todo = {
        open: false,
        data: null
      }
      this.offerApplied = {
        open: false,
        data: null
      }
      this.canContinue = false
      this.$refs.dialInput.handleClear()
    },
    inputChanged: debounce(function () {
      this.checkLoyaltyMember()
    }, 750),
    async checkLoyaltyMember() {
      this.canContinue = false
      this.phone.reset = true
      this.todo.data = null
      this.newCustomer.data = null
      this.phone.loading = true
      if (this.canProceedFindMember) {
        this.phone.reset = false
        try {
          const params = {
            dormant: false,
            phone: this.phone.number
          }
          const {data} = await this.$axios.get(`/loyalty/${this.company.slug}/members`, {params})
          if (data.count === 0) {
            this.newCustomer.data = {
              phone: this.phone.number
            }
          } else {
            this.$store.commit('marketing/setMember', data.results[0])
          }
          this.canContinue = true
        } catch (e) {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        } finally {
          this.phone.loading = false
        }
      }
    }
  },
}
</script>

<style scoped>
</style>